<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>
    <v-container grid-list-md>
      <v-progress-linear
        :active="isLoadingRequestDisable"
        indeterminate
        color="green accent-4"
        height="7"
      ></v-progress-linear>

      <v-form v-model="estaValido">
        <v-col cols="12">
          <v-container grid-list-md>
            <v-row>
              <v-col cols="3" class="text-center">
                <v-col cols="12">
                  <v-avatar color="grey lighten-2" size="200">
                    <img v-bind:src="displayImage" style="object-fit: cover;" class="white lighten-2"/>
                  </v-avatar>
                </v-col>

                <v-col cols="12">
                  <v-file-input
                    prepend-icon="mdi-camera"
                    placeholder="Alterar foto"
                    accept="image/*"
                    @change="changeProfilePic"
                  >
                  </v-file-input>
                </v-col>
              </v-col>

              <v-col cols="9">
                <v-col cols="12">
                  <v-text-field
                    v-model="actualEdit.nomeUsuario"
                    :rules="nomeRules"
                    name="nomeUsuario"
                    label="Nome Usuário"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="actualEdit.emailUsuario"
                    :rules="emailRules"
                    name="emailUsuario"
                    label="Email do Usuário"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="actualEdit.numeroRegistro"
                    name="numeroRegistro"
                    label="Credencial"
                    autocomplete="off"
                    append-icon="mdi-close"
                    @click:append="prependIconLimpar"
                  ></v-text-field>
                </v-col>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-left">
                <span>
                  <b>Dados Pessoais:</b>
                </span>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="actualEdit.cpfUsuario"
                  name="cpfUsuario"
                  label="CPF"
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="actualEdit.nivelUsuario"
                  name="nivelUsuario"
                  label="Nivel de Acesso"
                  readonly
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="text-left">
                <v-btn
                  color="blue darken-1"
                  text
                  small
                  @click="openModalChangePassword"
                >
                  Alterar Senha?
                </v-btn>
              </v-col>

              <v-col cols="12" class="text-right">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="#03B2EE" class="white--text" @click="descartarModificacoes" v-bind="attrs" v-on="on">
                      Descartar
                    </v-btn>
                  </template>
                  <span>Descartar as modificações do usuario</span>
                </v-tooltip>
                <v-btn :disabled="btnEditarPerfil" color="success" class="ml-2" @click="updateProfileUser">
                  Editar Perfil
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-form>
    </v-container>

    <ModalCustomSize
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :modalSize="modalCustomSize.size"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="updatePasswordUser"
    >
      <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>

      <v-row>
        <v-col cols="12" class="text-left">
          <span> Por favor insira sua senha atual para poder continuar: </span>
        </v-col>
        <v-col cols="12">
          <v-text-field
            :append-icon="showSenhaAntiga ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showSenhaAntiga ? 'text' : 'password'"
            v-model="senhaAntiga"
            name="senhaAntiga"
            label="Senha atual"
            @click:append="showSenhaAntiga = !showSenhaAntiga"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="showNewPasswordInput">
        <v-col cols="12" class="text-left">
          <span> Agora insira sua nova senha e depois confirme-a: </span>
        </v-col>
        <v-col cols="6">
          <v-text-field
            :append-icon="showDigitarSenha ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showDigitarSenha ? 'text' : 'password'"
            v-model="digitarSenha"
            name="senhaNova"
            label="Nova senha"
            :rules="[required('senha'), minLength('senha', 3)]"
            @click:append="showDigitarSenha = !showDigitarSenha"
          ></v-text-field>
        </v-col>

        <v-col cols="6">
          <v-text-field
            :append-icon="showDigitarSenhaNovamente ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showDigitarSenhaNovamente ? 'text' : 'password'"
            v-model="digitarSenhaNovamente"
            name="senhaNova"
            label="Confirmar senha"
            @click:append="
              showDigitarSenhaNovamente = !showDigitarSenhaNovamente
            "
          ></v-text-field>
        </v-col>
      </v-row>
    </ModalCustomSize>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import ModalCustomSize from "../components/ModalCustomSize";
import validation from "@/utils/validation";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";

export default {
  components: {
    ModalCustomSize,
    Alertas,
    AlertasModal,
  },

  data: () => ({
    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    alerta: {
      texto: "",
      tipo: ""
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    displayImage: null,
    ...validation,
    isLoadingRequestDisable: false,

    estaValido: false,
    btnEditarPerfil: false,

    nomeRules: [
        v => !!v || 'O campo Nome é obrigatório',
        v => (v && v.length <= 255) || 'O nome informado é muito grande.',
    ],
    emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],

    actualEdit: {
      numeroUsuario: null,
      nomeUsuario: null,
      emailUsuario: null,
      cpfUsuario: null,
      newImage: null,
      foto: null,
      numeroRegistro: null
    },

    modalCustomSize: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      size: "1080",
      isButtonsVisible: true,
      isButtonsDisabled: false,
      newPassword: {
        novaSenha: null,
      },
    },

    senhaAntiga: null,
    digitarSenha: null,
    digitarSenhaNovamente: null,

    showSenhaAntiga: false,
    showDigitarSenha: false,
    showDigitarSenhaNovamente: false,

    showNewPasswordInput: false,
  }),

  created() {
    this.initialize();
  },

  watch: {
    senhaAntiga() {
      this.validaSenhaDoUsuario(this.senhaAntiga);
    },

    digitarSenhaNovamente() {
      if (this.digitarSenha == this.digitarSenhaNovamente) {
        this.modalCustomSize.newPassword.novaSenha = this.digitarSenhaNovamente;
        this.modalCustomSize.isButtonsDisabled = false;
        this.alertaModal.tipo = "";
      } else {
        this.modalCustomSize.newPassword.novaSenha = null;
        this.modalCustomSize.isButtonsDisabled = true;
        this.alertaModal.texto = "A nova senha, ambas devem ser iguais!";
        this.alertaModal.tipo = 'erro';
      }
    },

    estaValido() {
      this.btnEditarPerfil = !this.estaValido
    },
  },

  methods: {
    async initialize() {
      try {
        this.returnAllProfileData();
      } catch (error) {
        console.log(error.response);
      }
    },

    async returnAllProfileData() {

      const tokenUser = { token: store.state.token };
      const response = await axios.put("/selecionaUsuario", tokenUser, this.config);

      this.actualEdit.numeroUsuario = response.data.numeroUsuario;
      this.modalCustomSize.numeroUsuario = response.data.numeroUsuario;
      this.actualEdit.nomeUsuario = response.data.nomeUsuario;
      this.actualEdit.emailUsuario = response.data.email;
      this.actualEdit.cpfUsuario = response.data.cpf;
      this.actualEdit.foto = response.data.foto;
      this.actualEdit.numeroRegistro = response.data.numeroRegistro
      this.actualEdit.newImage = null
      this.displayImage = this.actualEdit.foto;

      if (response.data.numeroNivel == 3) {
        this.actualEdit.nivelUsuario = "Usuário do Almoxarifado";
      } else if (response.data.indicadorNivelAcesso == 2) {
        this.actualEdit.nivelUsuario = "Usuário da Unidade";
      } else {
        this.actualEdit.nivelUsuario = "Admin";
      }
    },

    prependIconLimpar() {
      this.actualEdit.numeroRegistro = null
    },

    async validaSenhaDoUsuario(senhaAntiga) {
      try {
        let validations = { descricaoSenha: senhaAntiga, numeroUsuario: this.actualEdit.numeroUsuario, };

        let validate = await axios.put("/validaSenha", validations, this.config);

        if (validate.data) {
          this.showNewPasswordInput = true;
          this.alertaModal.tipo = "";
        } else {
          this.showNewPasswordInput = false;
          this.alertaModal.texto = "A senha necessita ser iqual há senha cadastrada no sistema";
          this.alertaModal.tipo = 'erro';
        }
      } catch (error) {
        console.log(error.response);
      }
    },

    async descartarModificacoes() {
      try {
        await this.returnAllProfileData();
      } catch (error) {
        console.log(error.response);
      }
    },

    async updateProfileUser() {
      try {
        this.isLoadingRequestDisable = true;
        await axios.put("atualizaPerfil", this.actualEdit, this.config);
        this.$socket.emit("insertLog");

        this.alerta.texto = "Suas informações de usuário foram atualizadas com sucesso!"
        this.alerta.tipo = 'sucesso';

        this.isLoadingRequestDisable = false;
        this.initialize();
      } catch (error) {
        console.log(error.response);
        this.alerta.texto = "Não foi possivel atualizar seu perfil, os campos de Nome e Email são obrigatórios.";
        this.alerta.tipo = 'erro';
      } finally {
        this.isLoadingRequestDisable = false;
      }
    },

    async updatePasswordUser() {
      try {
        let newPasswordChanges = {
          novaSenhaFuncionario: this.modalCustomSize.newPassword.novaSenha,
          numeroUsuario: this.actualEdit.numeroUsuario,
        };

        await axios.put("atualizaSenha", newPasswordChanges, this.config);
        this.$socket.emit("insertLog");
        this.$store.dispatch("logout");
        this.$router.push("/login");
      } catch (error) {
        console.log(error.response);
      }
    },

    changeProfilePic(image) {
      var reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => {
        this.displayImage = reader.result;
        this.actualEdit.newImage = reader.result;
      };
      reader.onerror = function (error) {
        console.log(error);
      };
    },

    openModalChangePassword() {
      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.isButtonsDisabled = true;
      this.modalCustomSize.buttonText = "Alterar Senha";
      this.modalCustomSize.formTitle = "Alterar senha";
      this.showNewPasswordInput = false;

      this.senhaAntiga = null;
      this.digitarSenha = null;
      this.digitarSenhaNovamente = null;
      this.modalCustomSize.newPassword.novaSenha = null;
    },
  },
};
</script>